module.exports = __webpack_public_path__ + "static/media/man_breaking_bird_home.fd3fdf16.gif";